import BaseCoinValueContainer from 'Engine/containers/ui/BaseCoinValueContainer';

export default class BetSelectorContainer extends BaseCoinValueContainer {
  constructor(...arg) {
    super(...arg);
    this.showCurrency = true;
  }
}
